module.exports = __webpack_public_path__ + "img/title-shiba.0cac8ac4.png";